export const actions = {
  PAISES_LOAD_REQUESTED: 'PAISES_LOAD_REQUESTED',
  PAISES_LOAD_SUCCEEDED: 'PAISES_LOAD_SUCCEEDED',
  PAISES_LOAD_FILED: 'PAISES_LOAD_FILED',

  PAIS_UPDATE_REQUESTED: 'PAIS_UPDATE_REQUESTED',
  PAIS_UPDATE_SUCCEEDED: 'PAIS_UPDATE_SUCCEEDED',
  PAIS_UPDATE_FILED: 'PAIS_UPDATE_FILED',

  PAIS_INSERT_REQUESTED: 'PAIS_INSERT_REQUESTED',
  PAIS_INSERT_SUCCEEDED: 'PAIS_INSERT_SUCCEEDED',
  PAIS_INSERT_FILED: 'PAIS_INSERT_FILED',

  PAIS_DELETE_REQUESTED: 'PAIS_DELETE_REQUESTED',
  PAIS_DELETE_SUCCEEDED: 'PAIS_DELETE_SUCCEEDED',
  PAIS_DELETE_FILED: 'PAIS_DELETE_FILED',
}

export const getPaisesAction = dispatch => {
  dispatch({
    type: actions.PAISES_LOAD_REQUESTED,
  })
}

export const onSubmitInsertPaisFormAction = (dispatch, formPais) => {
  dispatch({
    type: actions.PAIS_INSERT_REQUESTED,
    payload: formPais,
  })
}

export const onSubmitUpdatePaisFormAction = (dispatch, formPais) => {
  dispatch({
    type: actions.PAIS_UPDATE_REQUESTED,
    payload: formPais,
  })
}

export const deletePaisAction = (dispatch, id) => {
  dispatch({
    type: actions.PAIS_DELETE_REQUESTED,
    payload: id,
  })
}
